
import Pagination from '@/components/Pagination.vue'
import { defineComponent, getCurrentInstance, toRefs, reactive, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'

interface OrderList {
    order_no:               number,
    paid_at:                string,
    info:                   object,
    ship_amount:            number,
    colspan?:               number,
    channel_distribution?:  string // 二级分销渠道
}
export default defineComponent({
name: 'OrderList',
components: {Pagination},
setup() {
    const { proxy } = getCurrentInstance() as any
    const eBus = getCurrentInstance()?.appContext.config.globalProperties.$eBus
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    
    const data = reactive({
        filters: { // 筛选项
            channel_no: route.query.channel_no || store.state.user.userInfo.channel_no, // 渠道号
            channel_distribution:   'all',     // 子渠道
            start_time:     '',     // 开始日期
            end_time:       '',     // 结束日期
            phone:          '',     // 手机号
            order_no:       '',     // 订单号
            name:           ''
        },

        channelList: [], // 渠道列表
        orderList: <any>[], // 订单列表
        total: 0,
        pageSize: 10,
        currentPage: 1,
        // 获取订单列表
        getOrderList: () => {
            const { filters, currentPage, pageSize } = data
            proxy.$http.get(`/channel/orders?${joinParams({
                ...filters,
                page: currentPage,
                page_size: pageSize
            })}`).then(res => {
                if (res.code == 200) {
                    let orderList = res.data.data
                    let tmpList: Array<OrderList> = []
                    if (res.data.total) {
                        orderList.forEach(item => {
                            if (item.info && item.info.length === 1) {
                                tmpList.push({
                                    channel_distribution: item.channel_distribution,
                                    order_no: item.order_no,
                                    paid_at: item.paid_at,
                                    ship_amount: item.ship_amount,
                                    info: item.info[0]
                                })
                            } else if (item.info && item.info.length > 1) {
                                item.info.forEach(subItem => {
                                    tmpList.push({
                                        channel_distribution: item.channel_distribution,
                                        order_no: item.order_no,
                                        paid_at: item.paid_at,
                                        ship_amount: item.ship_amount,
                                        info: subItem
                                    })
                                })
                            }
                        })
                        tmpList[0].colspan = 2
                    }
                    data.orderList = tmpList
                    data.total = res.data.total
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        // 翻页
        onPageChange: (val) => {
            data.currentPage = val
            data.getOrderList()
        },
        onSizeChange  (val) {
            data.pageSize = val
            data.getOrderList()
        },
        // 返回上一页
        onBack: () => {
            eBus.emit('channelNo', data.filters.channel_no)
            router.go(-1)
        },
        // 搜索
        onSearch: () => {
            data.currentPage = 1
            data.getOrderList()
        },
        // 同一订单数据合并
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.colspan > 1) {
                if (rowIndex === 1 || rowIndex ===2) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    }
                }
            }
        },
        // 跳转到详情页
        onEdit: (id) => {
            router.push(`/partner/order-detail?channel_no=${data.filters.channel_no}&id=${id}`)
        },
        // 导出
        onExport: () => {
            const {filters, currentPage, pageSize} = data
            window.open(`${Keys.baseUrl}/channel/orders?${joinParams({
                ...filters,
                page: currentPage,
                page_size: pageSize,
                educe: 1
            })}`)
        },
        // 获取渠道列表
        getChannelList: () => {
            proxy.$http.get(`/channel/subordinate_channel_list?parent_channel_no=${data.filters.channel_no}`).then(res => {
                const {code, data:resData, msg} = res
                if (code != 200) {
                    return proxy.$message({
                        type: 'error',
                        message: msg
                    })
                }
                resData.unshift({
                    id: -1,
                    channel_no: 'all',
                    channel_name: '全部'
                })
                data.channelList = resData
            })
        }
    })

    data.getOrderList()
    // @ts-ignore
    if (data.filters.channel_no === 'wuhanfulu') {
        data.getChannelList()
    }
    return { ...toRefs(data) }
}
})
